import { Platform, useWindowDimensions } from 'react-native';
import { useMediaQuery } from 'react-responsive';

export const useIsMobileLayout = () => {
  return useMediaQuery({ maxWidth: 600 });
};

export const isMobileLayout = () => {
  return matchMedia('(max-width: 600px)').matches;
};

export const useIsWideDesktopLayout = () => {
  return useMediaQuery({ minWidth: 1366 });
};

export const useIsMobilePhone = () => {
  return useIsMobileLayout() && Platform.OS !== 'web';
};

export const useIsTabletLayout = () => {
  return !useIsMobileLayout() && Platform.OS !== 'web';
};

export const useIsLandscape = () => {
  const { width, height } = useWindowDimensions();
  return width > height;
};

export const isMobileBrowser = () =>
  Platform.OS === 'web' &&
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );

export const isDesktopBrowser = () =>
  Platform.OS === 'web' && !isMobileBrowser();

export const useTabletOrientation = () => {
  const isTablet = useIsTabletLayout();
  const { width, height } = useWindowDimensions();
  return isTablet ? (width > height ? 'landscape' : 'portrait') : 'any';
};
